import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Box, ChakraProvider } from '@chakra-ui/react';
import theme from './theme';

// Context providers
import { AuthProvider } from './context/AuthContext';

// Layout components
import Layout from './components/layout/Layout';
import AdminLayout from './components/layout/AdminLayout';
import CommitteeLayout from './components/layout/CommitteeLayout';

// Auth pages
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';

// Public pages
import Home from './pages/Home';
import ApplicationForm from './pages/ApplicationForm';

// import NominationProcess from './pages/NominationProcess'; // Replaced with NeighborhoodCouncilRegulations
import NeighborhoodCouncilRegulations from './pages/NeighborhoodCouncilRegulations';
import Timeline from './pages/Timeline';
import StatusCheck from './pages/StatusCheck';
import ProjectClosed from './pages/ProjectClosed';

// Admin pages
import AdminDashboard from './pages/admin/Dashboard';
import CandidatesList from './pages/admin/CandidatesList';
import CandidateProfile from './pages/admin/CandidateProfile';
import UserManagement from './pages/admin/UserManagement';
import Settings from './pages/admin/Settings';
import AdminEvaluations from './pages/admin/AdminEvaluations';
import Reports from './pages/admin/Reports';

// Committee pages
import CommitteeDashboard from './pages/committee/Dashboard';
import CandidateReview from './pages/committee/CandidateReview';
import EvaluationForm from './pages/committee/EvaluationForm';
import CommitteeEvaluations from './pages/committee/CommitteeEvaluations';

// Utility components
import ProtectedRoute from './components/auth/ProtectedRoute';
import NotFound from './pages/NotFound';
import PageViewTracker from './components/analytics/PageViewTracker';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <AuthProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <PageViewTracker />
          <Box minH="100vh">
            <Routes>
            {/* Public routes */}
            <Route path="/" element={<Layout />}>
              <Route index element={<ProjectClosed />} />
              {/* <Route path="nomination-process" element={<NominationProcess />} /> */}
              {/* Replaced with neighborhood-council-regulations */}
              <Route path="neighborhood-council-regulations" element={<NeighborhoodCouncilRegulations />} />
              <Route path="timeline" element={<Timeline />} />
              <Route path="apply" element={<ApplicationForm />} />
              <Route path="status" element={<StatusCheck />} />
              <Route path="project-closed" element={<ProjectClosed />} />
              <Route path="login" element={<Login />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
              <Route path="reset-password" element={<ResetPassword />} />
            </Route>

            {/* Admin routes */}
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="candidates" element={<CandidatesList />} />
              <Route path="candidates/:id" element={<CandidateProfile />} />
              <Route path="evaluations" element={<AdminEvaluations />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="reports" element={<Reports />} />
              <Route path="settings" element={<Settings />} />
            </Route>

            {/* Committee routes */}
            <Route 
              path="/committee" 
              element={
                <ProtectedRoute allowedRoles={['committee']}>
                  <CommitteeLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/committee/dashboard" replace />} />
              <Route path="dashboard" element={<CommitteeDashboard />} />
              <Route path="candidates" element={<CandidateReview />} />
              <Route path="candidates/:id" element={<CandidateProfile />} />
              <Route path="evaluate/:id" element={<EvaluationForm />} />
              <Route path="evaluations" element={<CommitteeEvaluations />} />
              <Route path="reports" element={<Reports />} />
            </Route>

            {/* 404 route */}
            <Route path="*" element={<NotFound />} />
            </Routes>
          </Box>
        </Router>
      </AuthProvider>
    </ChakraProvider>
  );
}

export default App;
